// === AUTO-GENERATED WITH generate-camel-svg-index.js ===

import aggregate from './aggregate24.svg'
import bean from './bean24.svg'
import breakpoint from './breakpoint.svg'
import camel from './camel.svg'
import camelContext from './camel-context-icon.svg'
import camelRoute from './camel-route.svg'
import camelRouteFolder from './camel-route-folder.svg'
import camelTracing from './camel-tracing.svg'
import channel from './channel24.svg'
import channeladapter from './channeladapter24.svg'
import channelpurger from './channelpurger24.svg'
import choice from './choice24.svg'
import commandmessage from './commandmessage24.svg'
import competingconsumers from './competingconsumers24.svg'
import componentFolder from './component-folder.svg'
import contentbasedrouter from './contentbasedrouter24.svg'
import contentfilter from './contentfilter24.svg'
import controlbus from './controlbus24.svg'
import convertbodyto from './convertbodyto24.svg'
import correlationidentifier from './correlationidentifier24.svg'
import customdataformat from './customdataformat24.svg'
import datatypechannel from './datatypechannel24.svg'
import deadletterchannel from './deadletterchannel24.svg'
import detour from './detour24.svg'
import distributionaggregate from './distributionaggregate24.svg'
import documentmessage from './documentmessage24.svg'
import durablesubscription from './durablesubscription24.svg'
import dynamicrouter from './dynamicrouter24.svg'
import editCamelRoute from './edit-camel-route.svg'
import encapsulatedsynchronous from './encapsulatedsynchronous24.svg'
import endpoint from './endpoint24.svg'
import endpointFile from './endpointFile24.svg'
import endpointFolder from './endpointFolder24.svg'
import endpointQueue from './endpointQueue24.svg'
import endpointRepository from './endpointRepository24.svg'
import endpointTimer from './endpointTimer24.svg'
import endpointdrools from './endpointdrools24.svg'
import endpoints from './endpoints.svg'
import endpointsActivemq from './endpoints/activemq24.svg'
import endpointsAtom from './endpoints/atom24.svg'
import endpointsBean from './endpoints/bean24.svg'
import endpointsCxf from './endpoints/cxf24.svg'
import endpointsCxfrs from './endpoints/cxfrs24.svg'
import endpointsEjb from './endpoints/ejb24.svg'
import endpointsFacebook from './endpoints/facebook24.svg'
import endpointsFile from './endpoints/file24.svg'
import endpointsFolder from './endpoints-folder.svg'
import endpointsFtp from './endpoints/ftp24.svg'
import endpointsFtps from './endpoints/ftps24.svg'
import endpointsImap from './endpoints/imap24.svg'
import endpointsImaps from './endpoints/imaps24.svg'
import endpointsJdbc from './endpoints/jdbc24.svg'
import endpointsJms from './endpoints/jms24.svg'
import endpointsLanguage from './endpoints/language24.svg'
import endpointsLinkedin from './endpoints/linkedin24.svg'
import endpointsLog from './endpoints/log24.svg'
import endpointsMqtt from './endpoints/mqtt24.svg'
import endpointsNetty from './endpoints/netty24.svg'
import endpointsNetty4 from './endpoints/netty424.svg'
import endpointsNetty4Http from './endpoints/netty4-http24.svg'
import endpointsNettyHttp from './endpoints/netty-http24.svg'
import endpointsNode from './endpoints-node.svg'
import endpointsPop3 from './endpoints/pop324.svg'
import endpointsPop3s from './endpoints/pop3s24.svg'
import endpointsQuartz from './endpoints/quartz24.svg'
import endpointsQuartz2 from './endpoints/quartz224.svg'
import endpointsRss from './endpoints/rss24.svg'
import endpointsSAP from './endpoints/SAP24.svg'
import endpointsSAPNetweaver from './endpoints/SAPNetweaver24.svg'
import endpointsSalesForce from './endpoints/salesForce24.svg'
import endpointsServlet from './endpoints/servlet24.svg'
import endpointsSftp from './endpoints/sftp24.svg'
import endpointsSmtp from './endpoints/smtp24.svg'
import endpointsSmtps from './endpoints/smtps24.svg'
import endpointsSnmp from './endpoints/snmp24.svg'
import endpointsSql from './endpoints/sql24.svg'
import endpointsTimer from './endpoints/timer24.svg'
import endpointsTwitter from './endpoints/twitter24.svg'
import endpointsWeather from './endpoints/weather24.svg'
import endpointsXslt from './endpoints/xslt24.svg'
import enrich from './enrich24.svg'
import envelopeWrapper from './envelopeWrapper24.svg'
import eventDrivenConsumer from './eventDrivenConsumer24.svg'
import eventMessage from './eventMessage24.svg'
import fileTransfer from './fileTransfer24.svg'
import filter from './filter24.svg'
import flow from './flow24.svg'
import generic from './generic24.svg'
import guaranteedMessaging from './guaranteedMessaging24.svg'
import idempotentConsumer from './idempotentConsumer24.svg'
import invalidMessageChannel from './invalidMessageChannel24.svg'
import loadBalance from './loadBalance24.svg'
import log from './log24.svg'
import marshal from './marshal24.svg'
import message from './message24.svg'
import messageBroker from './messageBroker24.svg'
import messageBus from './messageBus24.svg'
import messageDispatcher from './messageDispatcher24.svg'
import messageExpiration from './messageExpiration24.svg'
import messageSelector from './messageSelector24.svg'
import messageSequence from './messageSequence24.svg'
import messageStore from './messageStore24.svg'
import messaging from './messaging24.svg'
import messagingAdapter from './messagingAdapter24.svg'
import messagingBridge from './messagingBridge24.svg'
import messagingGateway from './messagingGateway24.svg'
import multicast from './multicast24.svg'
import node from './node24.svg'
import normalizer from './normalizer24.svg'
import pipeline from './pipeline24.svg'
import pointToPoint from './pointToPoint24.svg'
import pollEnrich from './pollEnrich24.svg'
import pollingConsumer from './pollingConsumer24.svg'
import process from './process24.svg'
import processManager from './processManager24.svg'
import processor from './processor24.svg'
import recipientList from './recipientList24.svg'
import requestReply from './requestReply24.svg'
import resequence from './resequence24.svg'
import returnAddress from './returnAddress24.svg'
import route from './route24.svg'
import routingSlip from './routingSlip24.svg'
import setBody from './setBody24.svg'
import sharedDatabase from './sharedDatabase24.svg'
import smartProxy from './smartProxy24.svg'
import split from './split24.svg'
import storeInLibrary from './storeInLibrary24.svg'
import testMessage from './testMessage24.svg'
import transactionalClient from './transactionalClient24.svg'
import transform from './transform24.svg'
import unmarshal from './unmarshal24.svg'
import wireTap from './wireTap24.svg'

enum IconNames {
  CamelContextIcon = 'CamelContextIcon',
  CamelRouteFolderIcon = 'CamelRouteFolderIcon',
  CamelRouteIcon = 'CamelRouteIcon',
  CamelIcon = 'CamelIcon',
  AggregateIcon = 'AggregateIcon',
  BeanIcon = 'BeanIcon',
  BreakpointIcon = 'BreakpointIcon',
  CamelTracingIcon = 'CamelTracingIcon',
  ChannelIcon = 'ChannelIcon',
  ChanneladapterIcon = 'ChanneladapterIcon',
  ChannelpurgerIcon = 'ChannelpurgerIcon',
  ChoiceIcon = 'ChoiceIcon',
  CommandmessageIcon = 'CommandmessageIcon',
  CompetingconsumersIcon = 'CompetingconsumersIcon',
  ComponentFolderIcon = 'ComponentFolderIcon',
  ContentbasedrouterIcon = 'ContentbasedrouterIcon',
  ContentfilterIcon = 'ContentfilterIcon',
  ControlbusIcon = 'ControlbusIcon',
  ConvertbodytoIcon = 'ConvertbodytoIcon',
  CorrelationidentifierIcon = 'CorrelationidentifierIcon',
  CustomdataformatIcon = 'CustomdataformatIcon',
  DatatypechannelIcon = 'DatatypechannelIcon',
  DeadletterchannelIcon = 'DeadletterchannelIcon',
  DetourIcon = 'DetourIcon',
  DistributionaggregateIcon = 'DistributionaggregateIcon',
  DocumentmessageIcon = 'DocumentmessageIcon',
  DurablesubscriptionIcon = 'DurablesubscriptionIcon',
  DynamicrouterIcon = 'DynamicrouterIcon',
  EditCamelRouteIcon = 'EditCamelRouteIcon',
  EncapsulatedsynchronousIcon = 'EncapsulatedsynchronousIcon',
  EndpointIcon = 'EndpointIcon',
  EndpointFileIcon = 'EndpointFileIcon',
  EndpointFolderIcon = 'EndpointFolderIcon',
  EndpointQueueIcon = 'EndpointQueueIcon',
  EndpointRepositoryIcon = 'EndpointRepositoryIcon',
  EndpointTimerIcon = 'EndpointTimerIcon',
  EndpointdroolsIcon = 'EndpointdroolsIcon',
  EndpointsFolderIcon = 'EndpointsFolderIcon',
  EndpointsNodeIcon = 'EndpointsNodeIcon',
  EndpointsIcon = 'EndpointsIcon',
  EnrichIcon = 'EnrichIcon',
  EnvelopeWrapperIcon = 'EnvelopeWrapperIcon',
  EventDrivenConsumerIcon = 'EventDrivenConsumerIcon',
  EventMessageIcon = 'EventMessageIcon',
  FileTransferIcon = 'FileTransferIcon',
  FilterIcon = 'FilterIcon',
  FlowIcon = 'FlowIcon',
  GenericIcon = 'GenericIcon',
  GuaranteedMessagingIcon = 'GuaranteedMessagingIcon',
  IdempotentConsumerIcon = 'IdempotentConsumerIcon',
  InvalidMessageChannelIcon = 'InvalidMessageChannelIcon',
  LoadBalanceIcon = 'LoadBalanceIcon',
  LogIcon = 'LogIcon',
  MarshalIcon = 'MarshalIcon',
  MessageIcon = 'MessageIcon',
  MessageBrokerIcon = 'MessageBrokerIcon',
  MessageBusIcon = 'MessageBusIcon',
  MessageDispatcherIcon = 'MessageDispatcherIcon',
  MessageExpirationIcon = 'MessageExpirationIcon',
  MessageSelectorIcon = 'MessageSelectorIcon',
  MessageSequenceIcon = 'MessageSequenceIcon',
  MessageStoreIcon = 'MessageStoreIcon',
  MessagingIcon = 'MessagingIcon',
  MessagingAdapterIcon = 'MessagingAdapterIcon',
  MessagingBridgeIcon = 'MessagingBridgeIcon',
  MessagingGatewayIcon = 'MessagingGatewayIcon',
  MulticastIcon = 'MulticastIcon',
  NodeIcon = 'NodeIcon',
  NormalizerIcon = 'NormalizerIcon',
  PipelineIcon = 'PipelineIcon',
  PointToPointIcon = 'PointToPointIcon',
  PollEnrichIcon = 'PollEnrichIcon',
  PollingConsumerIcon = 'PollingConsumerIcon',
  ProcessIcon = 'ProcessIcon',
  ProcessManagerIcon = 'ProcessManagerIcon',
  ProcessorIcon = 'ProcessorIcon',
  RecipientListIcon = 'RecipientListIcon',
  RequestReplyIcon = 'RequestReplyIcon',
  ResequenceIcon = 'ResequenceIcon',
  ReturnAddressIcon = 'ReturnAddressIcon',
  RouteIcon = 'RouteIcon',
  RoutingSlipIcon = 'RoutingSlipIcon',
  SetBodyIcon = 'SetBodyIcon',
  SharedDatabaseIcon = 'SharedDatabaseIcon',
  SmartProxyIcon = 'SmartProxyIcon',
  SplitIcon = 'SplitIcon',
  StoreInLibraryIcon = 'StoreInLibraryIcon',
  TestMessageIcon = 'TestMessageIcon',
  TransactionalClientIcon = 'TransactionalClientIcon',
  TransformIcon = 'TransformIcon',
  UnmarshalIcon = 'UnmarshalIcon',
  WireTapIcon = 'WireTapIcon',
}

export {
  IconNames,
  aggregate,
  bean,
  breakpoint,
  camel,
  camelContext,
  camelRoute,
  camelRouteFolder,
  camelTracing,
  channel,
  channeladapter,
  channelpurger,
  choice,
  commandmessage,
  competingconsumers,
  componentFolder,
  contentbasedrouter,
  contentfilter,
  controlbus,
  convertbodyto,
  correlationidentifier,
  customdataformat,
  datatypechannel,
  deadletterchannel,
  detour,
  distributionaggregate,
  documentmessage,
  durablesubscription,
  dynamicrouter,
  editCamelRoute,
  encapsulatedsynchronous,
  endpoint,
  endpointFile,
  endpointFolder,
  endpointQueue,
  endpointRepository,
  endpointTimer,
  endpointdrools,
  endpoints,
  endpointsActivemq,
  endpointsAtom,
  endpointsBean,
  endpointsCxf,
  endpointsCxfrs,
  endpointsEjb,
  endpointsFacebook,
  endpointsFile,
  endpointsFolder,
  endpointsFtp,
  endpointsFtps,
  endpointsImap,
  endpointsImaps,
  endpointsJdbc,
  endpointsJms,
  endpointsLanguage,
  endpointsLinkedin,
  endpointsLog,
  endpointsMqtt,
  endpointsNetty,
  endpointsNetty4,
  endpointsNetty4Http,
  endpointsNettyHttp,
  endpointsNode,
  endpointsPop3,
  endpointsPop3s,
  endpointsQuartz,
  endpointsQuartz2,
  endpointsRss,
  endpointsSAP,
  endpointsSAPNetweaver,
  endpointsSalesForce,
  endpointsServlet,
  endpointsSftp,
  endpointsSmtp,
  endpointsSmtps,
  endpointsSnmp,
  endpointsSql,
  endpointsTimer,
  endpointsTwitter,
  endpointsWeather,
  endpointsXslt,
  enrich,
  envelopeWrapper,
  eventDrivenConsumer,
  eventMessage,
  fileTransfer,
  filter,
  flow,
  generic,
  guaranteedMessaging,
  idempotentConsumer,
  invalidMessageChannel,
  loadBalance,
  log,
  marshal,
  message,
  messageBroker,
  messageBus,
  messageDispatcher,
  messageExpiration,
  messageSelector,
  messageSequence,
  messageStore,
  messaging,
  messagingAdapter,
  messagingBridge,
  messagingGateway,
  multicast,
  node,
  normalizer,
  pipeline,
  pointToPoint,
  pollEnrich,
  pollingConsumer,
  process,
  processManager,
  processor,
  recipientList,
  requestReply,
  resequence,
  returnAddress,
  route,
  routingSlip,
  setBody,
  sharedDatabase,
  smartProxy,
  split,
  storeInLibrary,
  testMessage,
  transactionalClient,
  transform,
  unmarshal,
  wireTap,
}
